import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';

import { ControlledTextField } from 'components/shared';

const ExternalSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common');

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <ControlledTextField
          control={control}
          variant="outlined"
          label={t('salaryScales.grid.scaleExt')}
          name="scaleExt"
        />
      </Grid>
      <Grid item xs={6}>
        <ControlledTextField
          control={control}
          variant="outlined"
          label={t('salaryScales.grid.seniorityExt')}
          name="seniorityExt"
        />
      </Grid>
      <Grid item xs={6}>
        <ControlledTextField
          control={control}
          variant="outlined"
          label={t('salaryScales.grid.claExt')}
          name="claExt"
        />
      </Grid>
    </Grid>
  );
};

export default ExternalSection;
